export default {
	'add-visit': 'إضافة زيارة',
	'edit-visit': 'تعديل زيارة',
	'visit-is-created': 'تم إضافة الزيارة',
	'visit-is-updated': 'تم تعديل الزيارة',
	'visit-is-queued': 'تم حفظ الزيارة - ستتم مزامنتها تلقائياً عند توفر الإنترنت',
	'the-visit': 'الزيارة',
	'daily-report': 'التقرير اليومي',
	'report-type': {
		important: 'مهم',
		complaint: 'شكوى',
		'normal-note': 'ملاحظة عادية',
	},
	'daily-report-is-updated': 'تم تحديث التقرير اليومي',
	'no-visits-to-show': 'لا توجد زيارات للعرض',
	'visit-details': 'تفاصيل الزيارة',
	'customer-details': 'تفاصيل الزبون',
	'new-customer': 'عميل جديد',
	total: 'الإجمالي',
	remaining: 'المتبقي',
	'insufficient-material-balance': 'لا يمكنك إضافة هذه المادة، ليس لديك رصيد كافٍ منها',
	'amount-exceeds-remaining': 'الكمية لا يمكن أن تتجاوز الرصيد المتبقي ({limit})',
	'available-pieces': 'متوفر {count} قطع فقط',
	'deliver-material': 'تسليم مادة أخرى',

	'balance-update': 'تعديل الرصيد',
	'balance-update-error': 'حدث خطأ أثناء تحديث الرصيد، يرجى نقر "تحديث" من أجل إعادة محاولة التحديث',

	'tab-scientific': 'علمي',
	'tab-commercial': 'تجاري',
	'tab-marketing': 'تسويقي',
	'create-order': 'إنشاء طلبية',
	'order-items': 'مواد الطلبية',
	order: 'الطلبية',
	'order-id': 'رقم الطلبية',
	'order-details': 'تفاصيل الطلبية',
	'no-order-items': 'لا توجد مواد في الطلبية',
	'order-delivery-date-without-items': 'يرجى إضافة مواد للطلبية أو تفريغ معلومات التسليم للمتابعة.',
	'add-plan-materials': 'إضافة مواد الخطة',
	'remove-plan-materials': 'إزالة مواد الخطة',

	'view-last-visit': 'الاطلاع على آخر زيارة',
	'no-last-visit': 'لا توجد زيارة سابقة',
	'no-samples-delivered': 'لم يتم تسليم أي عينات',
	'view-invoice': 'معاينة الفاتورة',
	debtor: 'مدين',
	'tab-invoice': 'الفاتورة',
	'tab-return': 'مرتجع',
	'quantity-packages': 'كمية (طرد)',
	'materials-total': 'مجموع المواد',
	'returns-total': 'إجمالي مبلغ المرتجع',
	'final-total': 'المجموع النهائي',
	discount: 'الخصم',
	'discount-amount': 'قيمة الخصم (إن وجد)',
	'payment-details': 'تفاصيل الدفع',
	'add-payment-method': 'إضافة طريقة دفع أخرى',
	'confirm-and-save': 'التأكيد والحفظ',
	'receive-material': 'استلام مادة أخرى',
	'request-material': 'طلب مادة أخرى',
	'scan-qr': 'مسح رمز الزبون',
	'qr-applied': 'تم اختيار الزبون من رمز QR',
	'qr-invalid': 'تعذّرت قراءة رمز الـ QR',
	'qr-customer-not-found': 'لا يوجد زبون مطابق لهذا الرمز',
	'qr-camera-error': 'تعذّر الوصول إلى الكاميرا',

	'return-reasons': {
		ravages: 'تالف',
		stocktaking: 'جرد',
		undefined: 'آخر',
	},
}